/**
 * Offline same-terminal parks — plan/28. Synced parks live on the server.
 */

export type LocalParkedTicket = {
  id: string;
  number: string;
  grossTotal: string;
  itemCount: number;
  terminalId: string;
  terminalName: string;
  createdAt: string;
  discountPct: string;
  taxRatePct: string;
  taxPriceMode: "inclusive" | "exclusive";
  notes: string | null;
  lines: Array<{
    productId: string;
    name: string;
    unitPrice: string;
    qty: number;
    trackLot?: boolean;
    trackSerial?: boolean;
    lotCode?: string;
    serialCode?: string;
  }>;
};

const PREFIX = "ix_pos_parked:";

export function localParkedStorageKey(
  companyRef: string,
  terminalId: string,
): string {
  return `${PREFIX}${companyRef}:${terminalId}`;
}

export function parseLocalParked(raw: string | null): LocalParkedTicket[] {
  if (raw == null || raw.trim() === "") return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (x): x is LocalParkedTicket =>
        x != null &&
        typeof x === "object" &&
        typeof (x as LocalParkedTicket).id === "string" &&
        typeof (x as LocalParkedTicket).number === "string" &&
        Array.isArray((x as LocalParkedTicket).lines),
    );
  } catch {
    return [];
  }
}

export function loadLocalParked(key: string): LocalParkedTicket[] {
  if (typeof localStorage === "undefined") return [];
  try {
    return parseLocalParked(localStorage.getItem(key));
  } catch {
    return [];
  }
}

export function saveLocalParked(
  key: string,
  tickets: readonly LocalParkedTicket[],
): void {
  if (typeof localStorage === "undefined") return;
  try {
    if (tickets.length === 0) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify([...tickets]));
  } catch {
    /* quota */
  }
}
